import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';

import { OnboardingProvider } from '../../context';
import { useInitializeSteps } from '../../hooks/useInitializeSteps';
import { useProxyWizard } from '../../hooks/useProxyWizard';

import { layoutDataDefault, layoutSteps, layoutStepsKeys } from './constants';

import type { LayoutDataType } from './types';

const LayoutOwnAIMultiGenderForest: React.FC = () => {
  const { proxyWizard, step } = useProxyWizard(layoutStepsKeys, layoutSteps);
  const { user } = useAccount();

  useInitializeSteps(proxyWizard, layoutStepsKeys);

  const onbData = user?.onboarding_data ?? {};

  const form = useForm<LayoutDataType>({
    defaultValues: {
      ...layoutDataDefault,
      gender: onbData.gender || null,
      name: onbData.name || '',
      email: onbData.email || '',
    },
    values: {
      ...layoutDataDefault,
      gender: onbData.gender || null,
      name: onbData.name || '',
      email: onbData.email || '',
    },
  });

  const StepComponent =
    layoutSteps[step as keyof typeof layoutSteps]?.component;

  if (!StepComponent) {
    return null;
  }

  return (
    <OnboardingProvider wizard={proxyWizard} steps={layoutSteps}>
      <FormProvider {...form}>
        <StepComponent />
      </FormProvider>
    </OnboardingProvider>
  );
};

export default LayoutOwnAIMultiGenderForest;
